import { HeartIcon } from "@heroicons/react/solid";
import React from "react";

function Footer() {
  console.clear();
  return (
    <footer className="bg-gray-800">
      <div className="container mx-auto flex flex-wrap p-5 flex-col md:flex-row items-center justify-center">
        <div className="rounded flex h-full items-center">
          <span className="title-font font-medium text-white mr-3">
            Made with
          </span>
          <HeartIcon className="text-red-400 w-6 h-6 flex-shrink-0 mr-3" />
          Riki Wahyudi
        </div>
      </div>
    </footer>
  );
}

export default Footer;
